/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Super_Sea_Llama_ExpandInputs */

const fr_super_sea_llama_expand = /** @type {(inputs: Super_Sea_Llama_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation du mot de passe`)
};

/**

* @param {Super_Sea_Llama_ExpandInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const super_sea_llama_expand = /** @type {((inputs?: Super_Sea_Llama_ExpandInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Super_Sea_Llama_ExpandInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_super_sea_llama_expand(inputs)
});